import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Button, ButtonToolbar, Card, CardBody, Col } from 'reactstrap';
import ProgramsTable from './ProgramsTable';
import { useProgramsUIContext } from '../ProgramsUIProvider';
import api from '@/utils/apiClient';

const ProgramsTableWrapper = () => {
  const programsUIContext = useProgramsUIContext();

  const { filters, checkedProgramIds } = useSelector((state) => state.cadsAIPrograms, shallowEqual);

  const downloadCSV = async () => {
    const csvData = await api.cadsAIPrograms.getProgramListCSV(filters);
    require('js-file-download')(
      csvData,
      `CADS_AI_Program_List__${new Date().toLocaleString().replace(/[\/:,\s]/gi, '_')}.csv`,
    );
  };

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody className="products-list">
          <div className="card__title">
            <ButtonToolbar className="products-list__btn-toolbar-top">
              <Button color="primary" onClick={programsUIContext.openNewProgramsDialog}>
                Add new
              </Button>
              <Button color="success" onClick={downloadCSV} outline>
                Export Programs
              </Button>
              {/*              <Button color="primary" onClick={null} outline>
                Clone
              </Button>*/}
              <Button
                color="danger"
                onClick={programsUIContext.openUpdateStatusDialog}
                outline
                disabled={checkedProgramIds.length === 0}
              >
                Update Status
              </Button>
            </ButtonToolbar>
          </div>
          <ProgramsTable />
        </CardBody>
      </Card>
    </Col>
  );
};

export default ProgramsTableWrapper;
